import SendAsUrgentImage from '@shared/assets/images/v2/send-as-urgent.svg';
import { MBText } from '@shared/components/MBText';
import { View } from '@shared/components/View';
import { MBButton } from '@shared/components/button';
import { MBImage } from '@shared/components/image';
import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { Styles } from '../styles';

export interface MBUrgentModalContentProps {
  count: number;
  onClose(): void;
  onRemoveSendAsUrgent(): void;
}

export function MBUrgentModalContent({
  count,
  onClose,
  onRemoveSendAsUrgent,
}: MBUrgentModalContentProps) {
  return (
    <View>
      <MBImage style={Styles.urgentImage} source={SendAsUrgentImage} />
      <View paddingBottom={2} />

      <MBText center>
        <MBText bold>{i18n('chat.modal.urgent.message.start', { count })}</MBText>
        {i18n('chat.modal.urgent.message.end')}
      </MBText>
      <View paddingBottom={2} />

      <MBText center size="small" color={Colors.v2.gray50}>
        <MBText bold size="small">
          {i18n('chat.modal.urgent.proTip.start')}
        </MBText>
        {i18n('chat.modal.urgent.proTip.end')}
      </MBText>
      <View paddingBottom={2} />

      <MBButton title={i18n('common.gotIt')} onPress={onClose} />

      {!!count && (
        <>
          <View paddingBottom={1} />
          <MBButton
            title={i18n('chat.modal.urgent.removeSendAsUrgent')}
            theme="outline"
            onPress={onRemoveSendAsUrgent}
          />
        </>
      )}
    </View>
  );
}
